"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.4871 4.48726C10.4871 4.21815 10.2689 4 9.99984 4C9.73074 4 9.51258 4.21815 9.51258 4.48726L9.51258 9.51271H4.48714C4.21803 9.51271 3.99988 9.73086 3.99988 9.99996C3.99988 10.2691 4.21803 10.4872 4.48714 10.4872H9.51258L9.51258 15.5127C9.51258 15.7818 9.73074 15.9999 9.99984 15.9999C10.2689 15.9999 10.4871 15.7818 10.4871 15.5127L10.4871 10.4872H15.5125C15.7817 10.4872 15.9998 10.2691 15.9998 9.99996C15.9998 9.73086 15.7817 9.51271 15.5125 9.51271L10.4871 9.51271L10.4871 4.48726Z",
    fill: fill
  }));
};

exports["default"] = _default;